import React, { FC } from "react";
import { capitalizeFirstLetterPerWord } from "../../services/Helper";

type AlarmValues = {
    status: string;
    setPoint: number;
}

type IProps = {
    hihiAlarm: AlarmValues;
    hiAlarm: AlarmValues;
    loAlarm: AlarmValues;
    loloAlarm: AlarmValues;
    processValue: number;
    setPoint: number;
    valueMax: number;
    valueMin: number;
    displayName: string;
    suffix?: string;
    iconLabel: string;
}

const CriticalMeasureGauge: FC<IProps> = ({ hihiAlarm, hiAlarm, loAlarm, loloAlarm, processValue, setPoint, valueMax: maxValue, valueMin: minValue, displayName, suffix, iconLabel }: IProps) => {
    const rangeValue = maxValue - minValue;
    const loloAlarmActive = loloAlarm.status === 'ENABLED' ? (processValue < loloAlarm.setPoint) : false;
    const loloAlarmWidth = (loloAlarm.status === 'ENABLED' ? loloAlarm?.setPoint - minValue : 0) / rangeValue;
    const loAlarmActive = loAlarm.status === 'ENABLED' ? (processValue < loAlarm.setPoint) : false;
    const loAlarmWidth = (loAlarm.status === 'ENABLED' ? loAlarm?.setPoint - minValue : 0) / rangeValue;

    const hiAlarmActive = hiAlarm.status === 'ENABLED' ? (processValue > hiAlarm.setPoint) : false;
    const hiAlarmWidth = (hiAlarm.status === 'ENABLED' ? hiAlarm?.setPoint - minValue : 0) / rangeValue;

    const hihiAlarmActive = hihiAlarm.status === 'ENABLED' ? (processValue > hihiAlarm.setPoint) : false;
    const hihiAlarmWidth = (hihiAlarm.status === 'ENABLED' ? hihiAlarm?.setPoint - minValue : 0) / rangeValue;

    const acceptedWidth = (hiAlarmWidth || hihiAlarmWidth || 1) - (loAlarmWidth || loloAlarmWidth);

    const setPointLocation = (setPoint - minValue) / rangeValue;
    const processValueLocation = (processValue - minValue) / rangeValue;

    return (
        <div className="d-flex py-1">
            {/* <div className="measure-icon">
                <img alt={capitalizeFirstLetterPerWord(iconLabel)} src={`/tank-critical-measurements/icon-${iconLabel}.svg`} />
            </div> */}
            <div className="pl-3 flex-1">
                <div className="d-flex justify-content-between">
                    <span className="item-sub-details">{displayName}</span>
                    <div className="d-flex align-items-center">
                        <div className="item-sub-details pr-1">
                            {processValue}
                        </div>
                        {suffix && <div className="text-secondary item-sub-details-suffix" dangerouslySetInnerHTML={{ __html: suffix }} />}
                    </div>
                </div>
                <div className="d-flex">
                    <div className="flex-1 d-flex rounded" style={{ height: 15, background: '#CBD5E1', border: '1px #CBD5E1 solid', position: 'relative' }}>
                        {setPoint >= minValue && setPoint <= maxValue && <div
                            className="measure-diamond"
                            style={{ left: `calc(${setPointLocation * 100}% - 5px)` }}
                        />}
                        <div style={{ width: `${loloAlarmWidth * 100}%`, borderRadius: '5px 0 0 5px', background: loloAlarm.status === 'ENABLED' && loloAlarmActive ?'#B71C1C':'inherit', height: '100%' }} />
                        <div style={{ width: `${loAlarmWidth ? (loAlarmWidth - loloAlarmWidth) * 100 : 0}%`, borderRadius: loloAlarm.status !== 'ENABLED' ? '5px 0 0 5px' : 0, borderLeft: loAlarm.status === 'ENABLED' ? '1px #dee2e6 solid' : 0, borderRight: loAlarm.status === 'ENABLED' ? '1px #dee2e6 solid' : 0, background: loAlarmActive ? '#F9A825' : 'inherit', height: '100%' }} />
                        <div style={{ width: `${acceptedWidth * 100}%`, borderRadius: loloAlarm.status !== 'ENABLED' && loAlarm.status !== 'ENABLED' ? (hihiAlarm.status !== 'ENABLED' && hiAlarm.status !== 'ENABLED' ? '0 5px 5px 0' : '5px 0 0 5px') : 0, background: 'white', height: '100%' }} />
                        <div style={{ width: `${hiAlarmWidth ? ((hihiAlarmWidth || 1) - loloAlarmWidth - (loAlarmWidth - loloAlarmWidth) - acceptedWidth) * 100 : 0}%`, borderRadius: hihiAlarm.status !== 'ENABLED' ? '0 5px 5px 0' : 0, borderLeft: hiAlarm.status === 'ENABLED' ? '1px #dee2e6 solid' : 0, borderRight: hiAlarm.status === 'ENABLED' ? '1px #dee2e6 solid' : 0, background: hiAlarmActive ? '#F9A825' : 'inherit', height: '100%' }} />
                        <div style={{ width: `${hihiAlarmWidth ? (1 - loloAlarmWidth - (loAlarmWidth - loloAlarmWidth) - acceptedWidth - ((hihiAlarmWidth || 1) - loloAlarmWidth - (loAlarmWidth - loloAlarmWidth) - acceptedWidth)) * 100 : 0}%`, borderRadius: '0 5px 5px 0', background: hihiAlarmActive ? '#B71C1C' : 'inherit', height: '100%' }} />
                    </div>
                </div>
                <div className="d-flex">
                    <div className="flex-1 d-flex justify-content-between" style={{ position: 'relative' }}>
                        <div
                            className="measure-triangle"
                            style={{ left: `calc(${processValueLocation * 100}% - ${processValueLocation>0.1 ? 7 : 0}px)` }}
                        />
                        <div className="measure-bar-label">{minValue}</div>
                        <div className="measure-bar-label">{maxValue}</div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CriticalMeasureGauge;
